import callApiAxiosClient from '../../axios/axios_client';
import { updateTechnicalIncidentStatusRequest } from '../../models';

async function updateTechnicalIncidentStatus({ id, status_id }: updateTechnicalIncidentStatusRequest): Promise<void> {
  const token = JSON.parse(localStorage.getItem('user')!);
  const authorization = 'Bearer ' + token.token;

  return callApiAxiosClient<void>({
    method: 'put',
    url: 'technicalincidents/status',
    headers: {
      'Content-Type': 'Application/json',
      Authorization: authorization,
    },
    data: {
      id,
      status_id,
    },
  });
}

export default updateTechnicalIncidentStatus;
